var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-stamp"},[_c('div',{staticClass:"c-stamp__img",style:({
      backgroundImage: "url(https://tuango-contest-assets.s3.amazonaws.com/fb/estrie.jpg)"
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }